import { axiosPost, axiosGet } from '@/api/AxiosApi';
import { deviceInfo } from '@/component/users/common/Device';

// 유저 정보
export type userInfoResProps = {
  auth_level: string;
  auth_lv_num: string;
  auth_status: string | null;
  auth_type: string | null;
  bank_type: string | null;
  birthday: string | null;
  country: string | null;
  email: string;
  is_chg_pw: string;
  last_chg_w_dt: string;
  mobile: string | null;
  mod_dt: string;
  nation_id: string | null;
  real_name: string | null;
  recommender_nm: string | null;
  reg_dt: string;
  seq: number;
  user_id: string;
  user_status: string;
};
export const users = async () => {
  const payload = {
    path: '/v1/users',
  };
  const { data: re } = await axiosGet(payload);
  return re;
};
// 로그인
export type loginProps = {
  email: string;
  user_pw?: string;
  pin_pw?: string;
  keep_login?: string | null;
  model_nm?: string | null;
  ip?: string | null;
};
export const login = async (aData: loginProps) => {
  const info = deviceInfo();
  const payload = {
    path: '/v1/users/login',
    body: { ...aData, ...info },
  };
  const { data: re } = await axiosPost(payload);
  return re;
};
// 핀번호로 로그인
export const loginWithPin = async (aData: loginProps) => {
  const info = deviceInfo();
  const payload = {
    path: '/v1/auth/login',
    body: { ...aData, ...info, type: 'pin' },
  };
  const { data: re } = await axiosPost(payload);
  return re;
};
// sns 로그인(web3auth) - 셔플 서버에 가입없이 idToken를 user_id로 임시적으로 사용
export const snsLogin = async (idToken: string) => {
  const payload = {
    path: '/v1/auth/login',
    body: {
      type: 'sns',
      user_id: idToken,
    },
  };
  try {
    const { data: re } = await axiosPost(payload);
    console.log(re);
    return re;
  } catch (e) {
    console.log(e);
  }
};
// 로그아웃
export const logout = () => {
  const payload = {
    path: '/v1/users/logout',
  };
  axiosPost(payload);
};
export type checkEmailProps = {
  email: string;
};
// 이메일 확인
export const checkEmail = async (email: string) => {
  const payload = {
    path: '/v1/users/email',
    body: { email },
  };
  const { data: re } = await axiosPost(payload);
  return re;
};

// 로그인 내역 조회
export type loginHistoryResProps = {
  browser: string;
  country: string;
  ip: string;
  login_dt: string;
  model_nm: string | null;
  name_eng: string;
  name_kor: string;
  os: string;
  seq: number;
  user_id: string;
  version: string;
};
export const loginHistory = async () => {
  const payload = {
    path: '/v1/users/login/history',
    body: {
      list_size: 10,
      page_num: 1,
    },
  };
  const { data: re } = await axiosPost(payload);
  return re;
};


export const readVersion = async () => {
  const payload = {
    path: '/version/v1',
    body: {
      name: window.location.host,
    },
  };
  const { data: res } = await axiosPost(payload);
  return res;
};
